import { createDeviceIdProvider } from '@vello/app-shell';

/**
 * A stable per-browser device fingerprint for operator login/device binding, persisted in local storage. It is sent at
 * login and on every refresh, so it is created atomically across tabs (Web Locks + re-read) and memoized for the page
 * lifetime, including when storage is unavailable (Codex r2 P2-3). The storage key is unchanged, so existing ids stay valid.
 */
export const deviceFingerprint: () => Promise<string> = createDeviceIdProvider({ storageKey: 'vello.admin.device' });
